{
  "status": {
    "draft": "Rascunho",
    "published": "Publicada",
    "closed": "Encerrada",
    "archived": "Arquivada"
  },
  "questionTypes": {
    "text": "Texto curto",
    "textarea": "Texto longo",
    "number": "Número",
    "currency": "Moeda (R$)",
    "select": "Seleção única",
    "multiselect": "Múltipla escolha",
    "checkbox": "Checkbox",
    "scale": "Escala",
    "nps": "NPS (0-10)",
    "rating": "Avaliação (estrelas)"
  },
  "triggerTypes": {
    "general": "Geral — aparece ao entrar na plataforma",
    "courseCompleted": "Após concluir um curso específico",
    "moduleCompleted": "Após concluir um módulo específico",
    "lessonCompleted": "Após concluir uma aula específica",
    "daysAfterSignup": "X dias após o cadastro",
    "daysAfterEnrollment": "X dias após a matrícula",
    "signupPeriod": "Período de cadastro (data inicial e final)"
  },
  "triggerConfig": {
    "general": {
      "short": "Aparece para todos os alunos logo ao entrar na plataforma.",
      "example": "Ex: Pesquisa de satisfação geral para coletar feedback amplo."
    },
    "courseCompleted": {
      "short": "Dispara quando o aluno conclui 100% das aulas de um curso específico.",
      "example": "Ex: Pedir NPS quando o aluno termina o curso completo \"JavaScript do Zero\"."
    },
    "lessonCompleted": {
      "short": "Dispara quando o aluno marca uma aula específica como concluída.",
      "example": "Ex: \"Como você avalia essa aula?\" — aparece no fim da aula de boas-vindas."
    },
    "moduleCompleted": {
      "short": "Dispara quando o aluno conclui todas as aulas de um módulo específico.",
      "example": "Ex: Pedir uma nota NPS depois que o aluno termina o módulo de JavaScript."
    },
    "daysAfterSignup": {
      "short": "Dispara quando se passam X dias desde que o aluno criou a conta.",
      "example": "Ex: \"Como está sendo sua experiência?\" 7 dias após o cadastro."
    },
    "daysAfterEnrollment": {
      "short": "Dispara X dias depois do aluno se matricular em um curso específico.",
      "example": "Ex: Pedir avaliação 30 dias após comprar o curso premium."
    },
    "signupPeriod": {
      "short": "Aparece apenas para alunos que se cadastraram dentro de um período específico.",
      "example": "Ex: Pesquisa para a turma de janeiro: cadastros entre 01/01 e 31/01."
    }
  },
  "list": {
    "title": "Pesquisas",
    "subtitle": "Crie e gerencie pesquisas customizáveis para seus alunos",
    "newSurvey": "Nova Pesquisa",
    "newSurveyTitle": "Nova Pesquisa",
    "stats": {
      "total": "Total",
      "published": "Publicadas",
      "responses": "Respostas",
      "questions": "Perguntas"
    },
    "tabs": {
      "all": "Todas",
      "draft": "Rascunho",
      "published": "Publicadas",
      "closed": "Encerradas"
    },
    "empty": {
      "title": "Nenhuma pesquisa encontrada",
      "description": "Crie sua primeira pesquisa para coletar feedback dos alunos",
      "create": "Criar pesquisa"
    },
    "actions": {
      "edit": "Editar",
      "duplicate": "Duplicar",
      "publish": "Publicar",
      "close": "Encerrar",
      "delete": "Excluir"
    },
    "card": {
      "anonymous": "Anônima",
      "questions": "Perguntas",
      "responses": "Respostas",
      "triggers": "Triggers",
      "createdAt": "Criada em {{date}}",
      "open": "Abrir →"
    },
    "deleteDialog": {
      "title": "Excluir pesquisa",
      "description": "Tem certeza que deseja excluir <bold>{{title}}</bold>? Todas as respostas serão perdidas.",
      "cancel": "Cancelar",
      "confirm": "Excluir"
    }
  },
  "edit": {
    "common": {
      "cancel": "Cancelar",
      "save": "Salvar",
      "add": "Adicionar"
    },
    "header": {
      "back": "Voltar",
      "editTitleHint": "Clique para editar título e descrição",
      "responsesCount_one": "{{count}} resposta",
      "responsesCount_zero": "{{count}} respostas",
      "responsesCount_other": "{{count}} respostas",
      "questionsCount_one": "{{count}} pergunta",
      "questionsCount_zero": "{{count}} perguntas",
      "questionsCount_other": "{{count}} perguntas",
      "edit": "Editar",
      "previewAsStudent": "Visualizar como aluno",
      "publish": "Publicar",
      "close": "Encerrar"
    },
    "tabs": {
      "questions": "Perguntas ({{count}})",
      "triggers": "Triggers ({{count}})",
      "results": "Resultados"
    },
    "questions": {
      "add": "Adicionar Pergunta",
      "empty": "Nenhuma pergunta ainda. Adicione a primeira!",
      "section": "Seção: {{section}}",
      "fullPreview": "Preview completa — como o aluno verá",
      "sampleOptionA": "Opção A",
      "sampleOptionB": "Opção B"
    },
    "triggers": {
      "infoTitle": "O que são gatilhos (triggers)?",
      "infoDescription": "Gatilhos definem <bold>quando sua pesquisa aparece para o aluno</bold>. Sem um gatilho, a pesquisa fica publicada mas não é mostrada a ninguém. Com um gatilho (ex: \"após concluir aula X\"), ela aparece automaticamente no momento certo, gerando respostas relevantes.",
      "infoMultiple": "Você pode adicionar <bold>mais de um gatilho</bold> — a pesquisa aparece assim que qualquer um deles for disparado.",
      "configured": "Gatilhos configurados ({{count}})",
      "add": "Adicionar gatilho",
      "emptyTitle": "Nenhum gatilho configurado",
      "emptyDescription": "Sem gatilhos, sua pesquisa está publicada mas não aparecerá para os alunos. Adicione o primeiro gatilho abaixo.",
      "addFirst": "Adicionar primeiro gatilho",
      "removed": "Gatilho removido",
      "days_one": "{{count}} dia",
      "days_zero": "{{count}} dias",
      "days_other": "{{count}} dias"
    },
    "results": {
      "emptyTitle": "Nenhuma resposta ainda",
      "emptyDescription": "Quando os alunos responderem, métricas, respondentes e estatísticas aparecerão aqui.",
      "perQuestion": "Análise por pergunta",
      "answersCount_one": "{{count}} resposta",
      "answersCount_zero": "{{count}} respostas",
      "answersCount_other": "{{count}} respostas",
      "promoters": "Promotores",
      "neutrals": "Neutros",
      "detractors": "Detratores",
      "average": "média"
    },
    "deleteQuestion": {
      "title": "Excluir pergunta",
      "description": "Excluir \"{{label}}\"?",
      "confirm": "Excluir",
      "success": "Pergunta excluída"
    },
    "questionDialog": {
      "labelRequired": "Pergunta é obrigatória",
      "updated": "Pergunta atualizada",
      "added": "Pergunta adicionada",
      "saveError": "Erro ao salvar pergunta",
      "editTitle": "Editar Pergunta",
      "newTitle": "Nova Pergunta",
      "label": "Pergunta *",
      "labelPlaceholder": "Ex: O que achou do curso?",
      "type": "Tipo",
      "section": "Seção (opcional)",
      "sectionPlaceholder": "Ex: Sobre o curso",
      "description": "Descrição (opcional)",
      "descriptionPlaceholder": "Ajuda ou contexto para o aluno",
      "placeholder": "Placeholder",
      "placeholderPlaceholder": "Texto dentro do campo",
      "options": "Opções (separadas por vírgula)",
      "optionsPlaceholder": "Opção A, Opção B, Opção C",
      "min": "Mínimo",
      "max": "Máximo",
      "required": "Obrigatória"
    },
    "triggerDialog": {
      "added": "Gatilho adicionado",
      "addError": "Erro ao adicionar gatilho",
      "title": "Novo gatilho",
      "description": "Escolha quando esta pesquisa deve aparecer para o aluno.",
      "whenLabel": "Quando esta pesquisa deve aparecer?",
      "selectCourse": "Selecione o curso",
      "change": "Trocar",
      "modulesCount_one": "{{count}} módulo",
      "modulesCount_zero": "{{count}} módulos",
      "modulesCount_other": "{{count}} módulos",
      "searchCourse": "Buscar curso...",
      "noCourses": "Nenhum curso encontrado",
      "selectModule": "Selecione o módulo",
      "lessonsCount_one": "{{count}} aula",
      "lessonsCount_zero": "{{count}} aulas",
      "lessonsCount_other": "{{count}} aulas",
      "noModules": "Esse curso não tem módulos",
      "selectLesson": "Selecione a aula",
      "noLessons": "Esse módulo não tem aulas",
      "daysLabel": "Após quantos dias?",
      "daysHint": "A pesquisa será exibida quando se passarem esse número de dias.",
      "signupFrom": "Cadastros a partir de",
      "signupUntil": "Cadastros até",
      "periodHint": "Apenas alunos cuja data de cadastro está dentro deste período receberão a pesquisa. Pode informar apenas uma das datas.",
      "submit": "Adicionar gatilho"
    },
    "settings": {
      "titleRequired": "Título é obrigatório",
      "saveError": "Erro ao salvar",
      "title": "Configurações da pesquisa",
      "description": "Edite título, descrição e opções de exibição.",
      "titleLabel": "Título *",
      "titlePlaceholder": "Ex: Pesquisa de satisfação — Curso de JavaScript",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Explique para o aluno o objetivo da pesquisa",
      "descriptionHint": "Aparece logo abaixo do título na tela de introdução.",
      "anonymous": "Resposta anônima",
      "anonymousHint": "Não guarda o aluno vinculado à resposta.",
      "allowMultiple": "Múltiplas respostas",
      "allowMultipleHint": "Permite o mesmo aluno responder mais de uma vez.",
      "xpReward": "XP ao responder",
      "xpRewardHint": "Pontos de gamificação que o aluno ganha ao concluir a pesquisa.",
      "window": "Janela de exibição (opcional)",
      "start": "Início",
      "end": "Fim",
      "windowPermanent": "<highlight>Pesquisa permanente:</highlight> sem início e sem fim, ela fica disponível enquanto estiver publicada.",
      "windowUntil": "Disponível <bold>agora até</bold> {{end}}.",
      "windowFrom": "Começa em <bold>{{start}}</bold> e fica permanente depois disso.",
      "windowRange": "Visível de <bold>{{start}}</bold> até <bold>{{end}}</bold>.",
      "saveChanges": "Salvar alterações"
    },
    "preview": {
      "badge": "Preview · Visão do aluno",
      "restart": "Reiniciar",
      "completed": "Concluído",
      "step": "Etapa {{current}} de {{total}}",
      "yourOpinionMatters": "Sua opinião importa",
      "defaultDescription": "Responda algumas perguntas rápidas e nos ajude a melhorar sua experiência.",
      "questionsCount_one": "{{count}} pergunta",
      "questionsCount_zero": "{{count}} perguntas",
      "questionsCount_other": "{{count}} perguntas",
      "start": "Começar agora",
      "previous": "Anterior",
      "submit": "Enviar resposta",
      "next": "Próxima",
      "thanks": "Obrigado!",
      "success": "Sua resposta foi enviada com sucesso",
      "xpEarned": "+{{xp}} XP ganhos",
      "selectPlaceholder": "Selecione",
      "npsNotLikely": "Nada provável",
      "npsVeryLikely": "Muito provável"
    },
    "metrics": {
      "total": "Total",
      "totalHint": "Respostas recebidas",
      "anonymousResponses": "Respostas anônimas",
      "unique": "Únicos",
      "anonymousHint": "Sem identificação",
      "uniqueHint": "Alunos distintos",
      "completion": "Conclusão",
      "completionHint": "Respostas finalizadas",
      "period": "Período",
      "periodHint": "Primeira → última"
    },
    "respondents": {
      "title": "Respondentes ({{count}})",
      "anonymous": "Resposta anônima",
      "answersAt": "Respostas · {{date}}",
      "question": "Pergunta",
      "noAnswer": "Sem resposta"
    }
  }
}
